import type { ApiISODateTimeString } from '#/api/types/ApiTypedDate';
import { SALARIES_API_ENDPOINT_ROOT } from '#/modules/salaries/utils/constants/salariesApiEndpointRoot';
import { getJson } from '#/utils/http/getJson';

export function salariesGetCompensationSurvey(): Promise<{
  alreadySubmitted: boolean;
  salaryModelCreated: ApiISODateTimeString;
}> {
  return getJson(SALARIES_API_ENDPOINT_ROOT);
}
